export default "__VITE_ASSET__CzIKDzWB__"